<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">原始月租</v-tab>
      <v-tab href="#tab-2">續約月租</v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="monthItemDataTableHeaders"
              :items="monthItemList"
              :search="searchMonthItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              item-key="Number"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title></v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchMonthItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-dialog
                    v-model="isShowEditMonthItemDialog"
                    v-if="isShowEditMonthItemDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ $t('quotation_item_return_month') }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedMonthItem.Number"
                                disabled
                                :label="$t('quotation_item_number')"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedMonthItem.Name"
                                disabled
                                :label="$t('quotation_item_name')"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedMonthItem.Unit"
                                disabled
                                :label="$t('quotation_item_unit')"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                :label="$t('quotation_item_month_number')"
                                v-model="editedMonthItem.MonthNumber"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedMonthItem.Quantity"
                                disabled
                                suffix="個月"
                                :label="$t('month_quantity')"
                              >
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedMonthItem.PayQuantity"
                                disabled
                                suffix="個"
                                :label="$t('month_quantity')"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-text-field
                                v-model="editedMonthItem.RentWarrantyPeriod"
                                disabled
                                :label="$t('quotation_item_rent_warranty_period')"
                              >
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                              <v-autocomplete
                                v-model="editedMonthItem.PayType"
                                :items="allPayType"
                                item-text="Name"
                                item-value="Type"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_data')"
                                disabled
                                label="收費方式"
                              >
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                              <v-autocomplete
                                v-model="editedMonthItem.PayTimeRangeType"
                                :items="payTimeRangeTypeList"
                                item-text="Name"
                                item-value="Type"
                                disabled
                                label="計費期間"
                              >
                              </v-autocomplete>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="3"
                              lg="3"
                              xl="3"
                              v-if="editedMonthItem.PayType === payType.Quantity"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayQuantityType"
                                :items="allPayQuantityType"
                                item-text="Name"
                                item-value="Type"
                                disabled
                                label="計量方式"
                              >
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedMonthItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.PayType`]="{ item }">
                {{ turnPayType(item.PayType) }}
              </template>
              <template v-slot:[`item.PayTimeRangeType`]="{ item }">
                {{ turnPayTimeRangeType(item.PayTimeRangeType) }}
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn
                  icon
                  @click="isShowEditMonthItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-eye
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="renewMonthItemDataTableHeaders"
              :items="renewMonthItemList"
              :search="searchRenewMonthItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              item-key="MonthNumber"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>續約月租品項</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchRenewMonthItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-dialog v-model="isShowEditRenewMonthItemDialog" persistent>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">續約月租品項</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogRenewMonthItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedRenewMonthItem.LicensePlate"
                                  label="續約車牌"
                                  disabled
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <month-item-autocomplete
                                  :fatherEditedItem="editedRenewMonthItem"
                                  :itemName="'quotation_item_number'"
                                  @setEditedMonthItem="setEditedRenewMonthItem"
                                  v-if="editedRenewMonthIndex === -1"
                                  refName="monthItemAutocomplete"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedRenewMonthItem.Number"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedRenewMonthItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  :label="$t('quotation_item_month_number')"
                                  v-model="editedRenewMonthItem.MonthNumber"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  label="原始保固期數"
                                  v-model="editedRenewMonthItem.RentWarrantyPeriod"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="增加保固期數"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedRenewMonthItem.AddRentWarrantyPeriod"
                                    :error-messages="errors[0]"
                                    @change="setTotalRentWarrantyPeriod"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      增加保固期數
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedRenewMonthItem.TotalRentWarrantyPeriod"
                                  label="總保固期數"
                                  disabled
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <ValidationProvider
                                  name="續約原因"
                                  :rules="{ required: true }"
                                  v-slot="{ errors }"
                                >
                                  <v-textarea
                                    outlined
                                    v-model="editedRenewMonthItem.RenewReason"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      續約原因
                                    </template>
                                  </v-textarea>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedRenewMonthItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedRenewMonthItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteRenewMonthItemDialog"
                    :deleteMessage="'quotation_item_delete_item_dialog_title'"
                    @closeDelete="closeDeleteRenewMonthItem"
                    @confirmDelete="confirmDeleteRenewMonthItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn
                  icon
                  @click="isShowEditRenewMonthItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="isShowDeleteRenewMonthItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import { HttpMonth } from '@/js/http-Manager'
import { PayType } from '@/js/PayType'
import { PayTimeRangeType } from '@/js/PayTimeRangeType'
import MonthItemAutocomplete from '../../MonthItemAutocomplete.vue'
import DeleteDialog from '../../DeleteDialog.vue'
extend('regex', regex)

export default {
  components: { MonthItemAutocomplete, DeleteDialog },
  name: 'RenewMonthSetting',
  data: () => ({
    payType: PayType,
    searchMonthItem: '',
    editedMonthItemIndex: -1,
    isShowEditMonthItemDialog: false,
    editedMonthItem: {
      Number: '',
      Name: '',
      RentQuantity: 1,
      PayQuantity: 0,
      Quantity: 1,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0,
      MonthNumber: '',
      PayType: 1,
      PayTimeRangeType: 1,
      PayQuantityType: 1
    },
    defaultMonthItem: {
      Number: '',
      Name: '',
      RentQuantity: 1,
      PayQuantity: 0,
      Quantity: 1,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0,
      MonthNumber: '',
      PayType: 1,
      PayTimeRangeType: 1,
      PayQuantityType: 1
    },
    payTimeRangeTypeList: [],
    editedRenewMonthItem: {
      Number: '',
      Name: '',
      LicensePlate: '',
      RentWarrantyPeriod: 0,
      AddRentWarrantyPeriod: 0,
      TotalRentWarrantyPeriod: 0,
      RenewReason: '',
      MonthNumber: ''
    },
    defaultRenewMonthItem: {
      Number: '',
      Name: '',
      LicensePlate: '',
      RentWarrantyPeriod: 0,
      AddRentWarrantyPeriod: 0,
      TotalRentWarrantyPeriod: 0,
      RenewReason: '',
      MonthNumber: ''
    },
    isShowEditRenewMonthItemDialog: false,
    isShowDeleteRenewMonthItemDialog: false,
    editedRenewMonthIndex: -1,
    searchRenewMonthItem: ''
  }),
  async mounted () {
    await this.getAllPayTimeRangeType()
  },
  computed: {
    monthItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('month_quantity'), align: 'end', value: 'Quantity' },
        { text: '計量數量', align: 'end', value: 'PayQuantity' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'RentQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        {
          text: this.$t('quotation_item_month_number'),
          align: 'end',
          value: 'MonthNumber'
        },
        {
          text: this.$t('quotation_item_rent_warranty_period'),
          align: 'end',
          value: 'RentWarrantyPeriod'
        },
        { text: '收費方式', align: 'center', value: 'PayType' },
        { text: '計費時間', align: 'center', value: 'PayTimeRangeType' },
        { text: '計量方式', align: 'center', value: 'PayQuantityType' },
        { text: this.$t('transfer_order_license_plate'), align: 'start', value: 'LicensePlate' },
        { text: this.$t('common_look'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    renewMonthItemDataTableHeaders () {
      return [
        { text: '續約車牌', align: 'start', value: 'LicensePlate' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: '月租序號', align: 'start', value: 'MonthNumber' },
        { text: '車牌', align: 'start', value: 'LicensePlate' },
        { text: '保固期數', align: 'start', value: 'RentWarrantyPeriod' },
        {
          text: '增加保固期數',
          align: 'start',
          value: 'AddRentWarrantyPeriod'
        },
        {
          text: '總保固期數',
          align: 'start',
          value: 'TotalRentWarrantyPeriod'
        },
        {
          text: '續約原因',
          align: 'start',
          value: 'RenewReason'
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    }
  },
  methods: {
    async getAllPayTimeRangeType () {
      let response = await HttpMonth.GetPayTimeRangeTypes()
      this.payTimeRangeTypeList = response.status === 200 ? response.data.Data : []
    },
    turnPayTimeRangeType (val) {
      return PayTimeRangeType.PayTimeRangeTypeName(val)
    },
    turnPayType (val) {
      return PayType.PayTypeName(val)
    },
    setEditedRenewMonthItem (val) {
      this.editedRenewMonthItem.Id = val.Id
      this.editedRenewMonthItem.Number = val.Number
      this.editedRenewMonthItem.Name = val.Name
      this.editedRenewMonthItem.Unit = val.Unit
      this.editedRenewMonthItem.Price = val.Price
      this.editedRenewMonthItem.IsMonthItem = val.IsMonthItem
      this.editedRenewMonthItem.StoreNo = val.StoreNo
      this.editedRenewMonthItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedRenewMonthItem = JSON.parse(JSON.stringify(this.editedRenewMonthItem))
    },
    setEditedMonthItem (val) {
      this.editedMonthItem.Id = val.Id
      this.editedMonthItem.Number = val.Number
      this.editedMonthItem.Name = val.Name
      this.editedMonthItem.Unit = val.Unit
      this.editedMonthItem.Price = val.Price
      this.editedMonthItem.IsMonthItem = val.IsMonthItem
      this.editedMonthItem.IsDelete = val.IsDelete
      this.editedMonthItem.StoreNo = val.StoreNo
      this.editedMonthItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedMonthItem.Remark = val.Remark
      this.changeMonthTotal()
      this.editedMonthItem = JSON.parse(JSON.stringify(this.editedMonthItem))
    },
    closeEditedMonthItem () {
      this.isShowEditMonthItemDialog = false
      this.editedMonthItem = JSON.parse(JSON.stringify(this.defaultMonthItem))
      this.editedMonthItemIndex = -1
    },
    isShowEditMonthItemDialogBtn (item) {
      this.editedMonthItemIndex = this.monthItemList.indexOf(item)
      this.editedMonthItem = JSON.parse(JSON.stringify(item))
      this.isShowEditMonthItemDialog = true
    },

    isShowDeleteRenewMonthItemDialogBtn (item) {
      this.editedRenewMonthIndex = this.renewMonthItemList.indexOf(item)
      this.isShowDeleteRenewMonthItemDialog = true
    },
    confirmDeleteRenewMonthItem () {
      this.$emit('deleteRenewMonthItem', this.editedRenewMonthIndex)
      this.closeDeleteRenewMonthItem()
    },
    closeDeleteRenewMonthItem () {
      this.editedRenewMonthIndex = -1
      this.isShowDeleteRenewMonthItemDialog = false
    },
    isShowEditRenewMonthItemDialogBtn (item) {
      this.editedRenewMonthIndex = this.renewMonthItemList.indexOf(item)
      this.editedRenewMonthItem = JSON.parse(JSON.stringify(item))
      this.isShowEditRenewMonthItemDialog = true
    },
    async saveEditedRenewMonthItem () {
      const isValid = await this.$refs.dialogRenewMonthItem.validate()
      if (!isValid) return
      this.$emit('setEditedRenewMonthItemIndex', this.editedRenewMonthIndex)
      this.$emit('setEditedRenewMonthItem', this.editedRenewMonthItem)
      this.closeEditedRenewMonthItem()
    },
    closeEditedRenewMonthItem () {
      this.editedRenewMonthIndex = -1
      this.editedRenewMonthItem = JSON.parse(JSON.stringify(this.defaultRenewMonthItem))
      this.isShowEditRenewMonthItemDialog = false
    },
    setTotalRentWarrantyPeriod () {
      this.editedRenewMonthItem.TotalRentWarrantyPeriod =
        this.editedRenewMonthItem.RentWarrantyPeriod * 1 +
        this.editedRenewMonthItem.AddRentWarrantyPeriod * 1
    }
  },
  props: [
    'isAllTextFieldDisabled',
    'monthItemList',
    'carQuantity',
    'allPayType',
    'allPayQuantityType',
    'repairCustomerId',
    'renewMonthItemList'
  ]
}
</script>
